/**
 * Cross-domain SSO auth check.
 *
 * Pings the dash domain to see if the user is already authenticated there.
 * If so, reveals the #sso-continue element which contains a "Continue" button
 * that triggers the OAuth2 code flow back through the dash domain, and hides
 * the standard login methods.
 *
 * Config is read from data attributes on #sso-continue:
 *   data-ping-url  – the dash domain's authorize?ping=on endpoint
 */
var el = document.getElementById('sso-continue')
if (el) {
  var pingUrl = el.dataset.pingUrl
  if (pingUrl) {
    // Abort the ping after 5 s so the login form is never stuck hidden
    var controller = new AbortController()
    var timer = setTimeout(function () { controller.abort() }, 5000)
    fetch(pingUrl, { credentials: 'include', signal: controller.signal })
      .then(function (r) { return r.json() })
      .then(function (data) {
        if (data.auth) {
          // Show account email
          var emailEl = document.getElementById('sso-account-email')
          if (emailEl && data.email) {
            emailEl.textContent = data.email
          }
          // Reveal continue, hide login methods
          el.classList.remove('d-none')
          var methods = document.getElementById('login-methods')
          if (methods) methods.classList.add('d-none')
          // "Use a different account" re-shows login methods
          var diffLink = document.getElementById('sso-use-different')
          if (diffLink) {
            diffLink.addEventListener('click', function (e) {
              e.preventDefault()
              el.classList.add('d-none')
              methods.classList.remove('d-none')
            })
          }
        }
      })
      .then(function () {
        // If SSO didn't activate, reveal the standard login form
        if (el.classList.contains('d-none')) {
          var methods = document.getElementById('login-methods')
          if (methods) methods.classList.remove('d-none')
        }
      })
      .catch(function () {
        // Ping failed or timed out – fall back to standard login form
        var methods = document.getElementById('login-methods')
        if (methods) methods.classList.remove('d-none')
      })
      .finally(function () { clearTimeout(timer) })
  }
}
